import React from 'react';

import battery0 from '../assets/batteryLevels/battery_0.png';
import battery1 from '../assets/batteryLevels/battery_1.png';
import battery2 from '../assets/batteryLevels/battery_2.png';
import battery3 from '../assets/batteryLevels/battery_3.png';
import battery4 from '../assets/batteryLevels/battery_4.png';
import battery5 from '../assets/batteryLevels/battery_5.png';
import battery6 from '../assets/batteryLevels/battery_6.png';
import battery7 from '../assets/batteryLevels/battery_7.png';
import battery8 from '../assets/batteryLevels/battery_8.png';

const batteryLevels = [
  { max: 3, img: battery0 },
  { max: 10, img: battery1 },
  { max: 20, img: battery2 },
  { max: 30, img: battery3 },
  { max: 40, img: battery4 },
  { max: 50, img: battery5 },
  { max: 60, img: battery6 },
  { max: 70, img: battery7 },
  { max: 10000, img: battery8 },

];

function BatteryLevelIndicator({ batteryLevel }) {
  const getImageForBatteryLevel = (level) => {
    if (level === -1) {
      return battery0;
    }
    return batteryLevels.find(battery => level <= battery.max)?.img;
  };

  return <img src={getImageForBatteryLevel(batteryLevel)} alt="Battery level indicator" />;
}

export default BatteryLevelIndicator;